import classNames from 'classnames'

import { Counter } from '../../Counter'
import { DocumentDraggableTableTitleCell } from '../DocumentDraggableTableTitleCell'

import { DEFAULT_DRAGGED_ITEMS_COUNT } from './DocumentDraggableCellClone.constants'
import { getDraggingCellRowStyle } from './DocumentDraggableCellClone.utils'

import * as styles from './DocumentDraggableCellClone.module.css'

function DocumentDraggableCellClone({
  className,
  count = DEFAULT_DRAGGED_ITEMS_COUNT,
  item,
  style,
}) {
  const cloneStyle = getDraggingCellRowStyle(style)

  const isMultiple = count > DEFAULT_DRAGGED_ITEMS_COUNT

  return (
    <div
      className={classNames(className, { [styles.multiple]: isMultiple })}
      style={cloneStyle}
    >
      <DocumentDraggableTableTitleCell
        className={styles.TableCellClone}
        item={item}
      />
      {isMultiple ? <Counter className={styles.counter} count={count} /> : null}
    </div>
  )
}

export default DocumentDraggableCellClone
